/**
 * Login redirect — sends unauthenticated admins to Cognito Managed Login.
 *
 * If the user is already authenticated, redirects to /dashboard.
 * Otherwise, initiates the OAuth login flow immediately (Google-only).
 */

import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function Login() {
  const { isAuthenticated, isLoading, login } = useAuth()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login()
    }
  }, [isLoading, isAuthenticated, login])

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 text-lg font-medium">Redirecting to sign in...</div>
        <div className="text-sm text-muted-foreground">Please wait.</div>
      </div>
    </div>
  )
}
